<template>
  <div class="page">
    <SiteHero
      pageTitle="Programs"
      pageDescription="Elite Training Programs"
    />
  
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div
            v-for="(program, index) in programsData"
            :key="program.key"
          >
            <div class="mb-16">
              <div class="flex flex-col md:flex-row gap-12 items-center mb-8">
                <!-- Image container -->
                <div class="w-full md:w-1/4">
                  <img 
                    :src="require(`@/assets/images/programs/${program.thumbnail}`)"
                    :alt="program.name"
                    class="w-full rounded-lg"
                  />
                </div>
                
                <!-- Text content -->
                <div class="w-full md:w-3/4 space-y-4">
                  <div class="space-y-1">
                    <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 uppercase">
                      {{ program.name }}
                    </h2>
                  </div>
                  
                  <p class="text-gray-700 leading-relaxed">
                    {{ program.description }}
                  </p>

                  <div>
                    <ButtonLink 
                      text="LEARN MORE"
                      :url="program.programUrl"
                      color="black"
                    />
                  </div>
                </div>
              </div>
              
              <!-- Divider - only show if not last -->
              <hr v-if="index !== programsData.length - 1" class="mt-12 border-t border-gray-200">
            </div>
          </div>
        </div>
      </div>

      <Testimonials />
    </div>

    <SiteFooter />
  </div>
</template>
  
<script>
import SiteFooter from '../components/Footer/SiteFooter.vue';
import SiteHero from '../components/Hero/SiteHero.vue';
import ButtonLink from '../components/Common/ButtonLink.vue';
import Testimonials from '../components/HomePage/Testimonials.vue';
import programsData from '../data/programs.json';
import '../assets/styles/page.css';

export default {
  name: 'ProgramsPage',
  components: {
    SiteFooter,
    SiteHero,
    ButtonLink,
    Testimonials
  },
  data() {
    return {
      programsData: programsData.programs
    }
  }
};
</script>
